import { AxiosRequestConfig } from 'axios';
import { siteIdMiddleware } from '../middleware/site-id';
import { silentFailMiddleware } from '../middleware/silent-fail';
import { urlAndCredentialsMiddleware } from '../middleware/url-and-credentials';
import { timeoutMiddleware } from '../middleware/timeout';
import { encodeHtmlMiddleware } from '../middleware/encode-html';

const middlewares = [
  siteIdMiddleware,
  silentFailMiddleware,
  urlAndCredentialsMiddleware,
  timeoutMiddleware,
  encodeHtmlMiddleware,
];

/**
 * Processes an Axios request configuration through a chain of middleware functions before sending it.
 * The middleware functions are applied sequentially using the `Array.prototype.reduce()` method.
 */
export const requestInterceptor = (config: AxiosRequestConfig): AxiosRequestConfig => middlewares.reduce((acc, middleware) => middleware(acc), { ...config });
